import { render, staticRenderFns } from "./BaseTablePagedWithSearch.vue?vue&type=template&id=7ebbdbf0&scoped=true&"
import script from "./BaseTablePagedWithSearch.vue?vue&type=script&lang=js&"
export * from "./BaseTablePagedWithSearch.vue?vue&type=script&lang=js&"
import style0 from "./BaseTablePagedWithSearch.vue?vue&type=style&index=0&id=7ebbdbf0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebbdbf0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardTitle,VDataTable,VDivider,VPagination,VRow,VSpacer,VTextField})
